import cn from 'classnames';
import React from 'react';
import { NumericFormat } from 'react-number-format';
import { Text } from 'src/components/text/Text';
import { useLocale } from 'src/hooks/use-locale';

import styles from './InstallmentsInput.css';

const MIN_VALUE = 0;
const MAX_VALUE = 99999;

interface Props {
  id: string;
  value: string;
  onChange: (val: string) => void;
  className?: string;
}

export const InstallmentsInput = ({
  id,
  value: inputValue,
  onChange,
  className,
}: Props) => {
  const t = useLocale();
  const checkLimits = ({ value }) => {
    return value === '' || (value > MIN_VALUE && value <= MAX_VALUE);
  };

  return (
    <div className={styles.InstallmentsInput}>
      <Text as="h3" variant="h3" className={styles.InstallmentsInput__Title}>
        {t('plan_your_budget')}
      </Text>
      <Text
        as="p"
        variant="body2Tight"
        className={styles.InstallmentsInput__Description}
      >
        {t('enter_your_purchase_amount_here')}
      </Text>

      <Text as="span" variant="body1Tight">
        <NumericFormat
          id={id}
          className={cn(styles.InstallmentsInput__Input, className)}
          value={inputValue}
          onValueChange={({ value }) => {
            onChange(value);
          }}
          thousandSeparator=","
          displayType="input"
          decimalScale={0}
          fixedDecimalScale
          isAllowed={checkLimits}
          allowNegative={false}
          inputMode="numeric"
        />
      </Text>
    </div>
  );
};
